import HawkCatcher from '@hawk.so/javascript';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.css';
import reportWebVitals from './reportWebVitals';

new HawkCatcher({
  token:
    'eyJpbnRlZ3JhdGlvbklkIjoiZWVkZDA4M2QtMDEzOS00MWI2LWIyZTAtMzQxNWY0YjdmMjFiIiwic2VjcmV0IjoiYmVjNGY1MDktMzg5Yi00YWVhLWE0ZmQtMjcyMGU3N2QxODYwIn0=',
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
